import { useContext, useEffect } from 'react';
import { Box, Heading, Icon, Paragraph, TextButton } from '@zillow/constellation-10';
import { IconRateUnhappyFilled } from '@zillow/constellation-icons';
import { useIdVerificationCallbacks, useTermSet } from '../../../IdvContext';
import { ExitReason, TermSet } from '../../../../../models';
import { USER_NOT_FOUND_LOCKED_OUT_LINK } from '../../../constants/urls';
import { WizardContext } from '../../../wizard/WizardContext';

function LandlordContent() {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Icon size="lg" css={{ color: 'icon.subtle' }}>
        <IconRateUnhappyFilled />
      </Icon>
      <Heading level={2} textStyle="heading-sm">
        We can’t verify your identity
      </Heading>
      <Paragraph>
        We couldn’t verify your identity with the information provided. Please wait for 30 minutes and check that all
        information is correct, including your legal name, address, phone number, and Social Security number before
        submitting again. During this time, you won’t be able to access applicant’s information, including credit and
        background report.
      </Paragraph>
    </Box>
  );
}

function RenterContent() {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default', alignItems: 'flex-start' }}>
      <Icon size="lg" css={{ color: 'icon.subtle' }}>
        <IconRateUnhappyFilled />
      </Icon>
      <Heading level={2} textStyle="heading-sm">
        Couldn’t verify your identity
      </Heading>
      <Paragraph>
        Wait 30 minutes and check that all information is correct before submitting again. During this time, you won’t
        be able access credit and background services.
      </Paragraph>
      <TextButton asChild>
        <a href={USER_NOT_FOUND_LOCKED_OUT_LINK} target="_blank" rel="noopener noreferrer">
          Learn more
        </a>
      </TextButton>
    </Box>
  );
}

export default function ErrorUserNotFoundLockedOutStep() {
  const { setOnNext } = useContext(WizardContext);
  const { onExit } = useIdVerificationCallbacks();
  const termSet = useTermSet();

  useEffect(() => {
    setOnNext(() => async () => onExit({ reason: ExitReason.UserNotFoundLockedOut, success: false }));
    return () => setOnNext(null);
  }, [onExit, setOnNext]);

  return termSet === TermSet.LandlordScreening ? <LandlordContent /> : <RenterContent />;
}
